import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GrammarGuideList } from './GrammarGuideList';
import { OeAppService } from '../oe-app.service';

@Injectable()
export class GrammarGuideService {
  constructor(private http: HttpClient, private readonly oeApp: OeAppService) {}

  getList() {
    const url = `${this.oeApp.thirdPartyServiceHost}/v1/tools/grammer`;
    return this.http.get<GrammarGuideList>(url);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/grammar-guide/grammar-guide.service.ts